import React, { useMemo, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import SearchIcon from "../../../../icons/search.icon";
import PlusIcon from "../../../../icons/plus.icon";
import CheckIcon from "../../../../icons/check.icon";
import tableStyles from "../index.module.scss";
import styles from "./tags-dropdown.module.scss";

const getTagClass = (tag) => {
  if ((tag?.textColor || "").includes("support-alert")) {
    return tableStyles.tagAlert;
  }
  return tableStyles.tagPurple;
};

export const TagsDropdown = ({ tags = [] }) => {
  const [searchValue, setSearchValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTag, setSelectedTag] = useState(
    tags[0]?.label || "Strategic Partner"
  );

  const filteredTags = useMemo(() => {
    const baseTags = [{ label: "Strategic Partner" }, ...tags];
    if (!searchValue) return baseTags;
    return baseTags.filter((tag) =>
      tag.label.toLowerCase().includes(searchValue.toLowerCase())
    );
  }, [searchValue, tags]);

  const handleToggle = (nextShow) => setIsOpen(nextShow);
  const handleSelect = (label) => {
    setSelectedTag(label);
  };

  return (
    <Dropdown
      align="start"
      className={styles.dropdown}
      onToggle={handleToggle}
    >
      <Dropdown.Toggle
        className={`${styles.toggle} ${isOpen ? styles.toggleOpen : ""}`}
        variant="link"
      >
        <div className={styles.toggleContent}>
          {tags.length > 0 ? (
            tags.map((tag, index) => (
              <span
                key={`${tag.label}-${index}`}
                className={`${tableStyles.tag} ${getTagClass(tag)}`}
              >
                {tag.label}
              </span>
            ))
          ) : (
            <span className={styles.emptyText}>No tags</span>
          )}
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.menuWrapper}>
        <div className={styles.menu}>
          <div className={styles.searchRow}>
            <SearchIcon className={styles.searchIcon} />
            <input
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Search tags"
              className={styles.searchInput}
              aria-label="Search tags"
            />
          </div>

          <div className={styles.tagsList}>
            {filteredTags.length > 0 ? (
              filteredTags.map((tag, index) => {
                const isSelected = selectedTag === tag.label;
                return (
                  <button
                    type="button"
                    key={`${tag.label}-menu-${index}`}
                    className={styles.tagItem}
                    onClick={() => handleSelect(tag.label)}
                  >
                    {isSelected && (
                      <CheckIcon className={styles.tagCheckIcon} />
                    )}
                    <span className={styles.tagLabel}>{tag.label}</span>
                  </button>
                );
              })
            ) : (
              <div className={styles.emptyState}>No tags found</div>
            )}
          </div>

          {searchValue ? (
            <button
              type="button"
              className={styles.addButton}
              onClick={() => setSearchValue("")}
            >
              <PlusIcon className={styles.addIcon} />
              <span className={styles.addLabel}>Add “{searchValue}”</span>
            </button>
          ) : null}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};